import React from 'react'

/**
 * 页面授权的共享内容容器。
 * 独立授权页和 Profile 里的嵌入面板都通过这里承载当前页面、状态提示和授权记录，
 * 避免两套布局随着需求变更逐渐不一致。
 */
const VibeOwnerAccessPermissionPanel = ({
    setupState,
    setupNotice,
    reportGuide,
    listHint,
    applicationEntryUrl,
    applicationEntryLabel = '打开应用',
    onOpenApplication,
    onCreatePermission,
    onRenderRouteSync,
    children,
}) => setupState === 'REPORT_PAGES' ? reportGuide : (
    <div className="vibe-owner-access-permission-panel vibe-owner-access-list">
        {setupState === 'GRANT_ACCESS' && setupNotice}
        <div className="vibe-owner-access-list-panel">
            <div className="vibe-owner-access-list-heading">
                <div>
                    <h5 className="ant-typography">授权记录</h5>
                    {listHint && <span className="vibe-owner-access-list-heading-hint">{listHint}</span>}
                </div>
                <div className="ant-space">
                    {applicationEntryLabel && <button type="button" className="ant-btn" disabled={!applicationEntryUrl} onClick={onOpenApplication}>{applicationEntryLabel}</button>}
                    {setupState === 'COMPLETE' && <button type="button" className="ant-btn ant-btn-primary" onClick={onCreatePermission}>配置权限</button>}
                </div>
            </div>
            {children}
        </div>
        <details className="vibe-owner-access-maintenance">
            <summary>页面有更新？ <span>同步页面</span></summary>
            {onRenderRouteSync?.()}
        </details>
    </div>
)

export default VibeOwnerAccessPermissionPanel
